/**
 * Note To Self for improvement: Should have create a common state management that is reusable.
 */
(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('FilterBarCtrlService', FilterBarCtrlService);

    function FilterBarCtrlService(lodash, GenericModel, FILTER_OPERATOR_CONSTANT, CommonHelper, $filter) {
        return function (options) {
            let state = {
                applied_filters: []
            };
            const events = {};
            init();
            return ExposedMethods;

            function ExposedMethods() {
                return {
                    // Common Methods
                    hasType: hasType,
                    getMessageLabel: getMessageLabel,
                    getGeneratedQuery: getGeneratedQuery,
                    registerEvent: registerEvent,
                    getOptions: getOptions,
                    reset: reset,
                    refresh: refresh,
                    setQuery: setQuery,
                    getLabels: getLabels,
                    getFilterBarOptions: getFilterBarOptions,

                    // Filters Methods
                    getState: getState,
                    addFilter: addFilter,
                    removeApplied: removeApplied,
                    getFilterTypeOption: getFilterTypeOption,
                    applyFilter: applyFilter,
                    validateFilter: validateFilter,

                    // Sorting
                    applySort: applySort,

                    // Search
                    applySearch: applySearch
                };
            }

            function init() {
                //initTestData();

                var loadFiltersOnLoad = lodash.get(options, 'types.get_filters_on_init', true);
                if (loadFiltersOnLoad) {
                    getFilterList();
                }
            }

            function refresh() {
                return getFilterList();
            }

            function getFilterList() {
                var url = options.types.filter.datasource.init.url;
                var method = options.types.filter.datasource.init.method;
                var model = new GenericModel(url);
                var promise = model[method]().$promise.then(function (res) {
                    lodash.set(state, 'filter_fields', res.types);
                    lodash.set(state, 'filter_options', res.options);

                    // check if there are no existing applied filters
                    // and that there are no filter_temp for processing
                    // set default_filters as filter temp for processing
                    if (lodash.get(state, 'applied_filters', []).length === 0
                        && lodash.get(state, 'filter_temp', []).length === 0) {
                        lodash.set(state, 'filter_temp', lodash.get(res, 'default_filters.filters', []));
                    }

                    setFiltersFromTemp();
                }, function (res) {
                    console.warn(res); // eslint-disable-line no-console
                });

                return promise
            }

            function hasType(type) {
                return !!options.types[type];
            }

            function registerEvent(eventName, func) {
                events[eventName] = func;
            }

            function callEvent(eventName) {
                if (lodash.has(events, eventName)) {
                    events[eventName]();
                }
            }

            function getOptions(type) {
                return lodash.get(options.types, type, {});
            }

            function addFilter(filter) {
                const filterCopy = angular.copy(filter);
                filterCopy.incomplete = true;
                state.applied_filters.push(filterCopy);
                if (lodash.has(filter, 'operator') && !lodash.isEmpty(filter.operator)) {
                    if (['in', 'not_in'].indexOf(filter.operator)) {
                        callEvent('refreshGrid');
                    } else {
                        if (lodash.has(filter, 'value') && !lodash.isEmpty(filter.value)) {
                            callEvent('refreshGrid');
                        }
                    }

                }
            }

            function getState() {
                return state;
            }

            function removeApplied(filter) {
                const index = lodash.findIndex(state.applied_filters, {$$hashKey: filter.$$hashKey});
                state.applied_filters.splice(index, 1);
                callEvent('refreshGrid');
            }

            function applyFilter(filter, options) {
                const result = validateFilter(filter, options);
                if (!result.success) return result;

                const selectedOptions = lodash.find(options, {operator: filter.operator});

                filter.option_value = selectedOptions.value;
                filter.option_label = selectedOptions.value_label;
                filter.operator_label = selectedOptions.label;
                filter.incomplete = false;
                callEvent('refreshGrid');
                return {success: true};
            }

            function validateFilter(filter, options) {
                if (!lodash.has(filter, 'operator')) {
                    return {success: false, message: getMessageLabel('no_operator_selected')};
                }

                const selectedOptions = lodash.find(options, {operator: filter.operator});

                // check if multiple enum type, if yes check for all values is filled
                var type = lodash.get(filter, 'type')
                if ($filter('isMultipleEnumType')(type)) {
                    var currentFilterOptions = lodash.get(filter, 'options', {});
                    var currentFilterOptionKeys = lodash.keys(currentFilterOptions);

                    const value = lodash.get(selectedOptions, 'value', {});
                    const cleansedValue = $filter('cleanseValue')(value);

                    var valueKeys = lodash.keys(cleansedValue);
                    var uniqueValueKeys = lodash.xor(valueKeys, currentFilterOptionKeys);
                    if (uniqueValueKeys.length !== 0) {
                        return {success: false, message: getMessageLabel('no_value_set')};
                    }
                }

                if ([FILTER_OPERATOR_CONSTANT.EXISTS, FILTER_OPERATOR_CONSTANT.NOT_EXISTS].indexOf(selectedOptions.operator) < 0) {
                    if (!(lodash.has(selectedOptions, 'value')) || CommonHelper.isEmpty(selectedOptions.value)) {
                        return {success: false, message: getMessageLabel('no_value_set')};
                    }
                }
                return {success: true};
            }

            function getFilterTypeOption(filter) {
                var filterObj = lodash.find(state.filter_fields, {name: filter.name});
                var filterSettings = lodash.get(filterObj, 'settings', {});

                let standardFilterOptions = [];
                var typedFilterOptions = lodash.get(state, 'filter_options.form.' + filter.type + '.options', []);
                if (lodash.has(filterObj, 'settings.appendStandardOptions') && filterObj.settings.appendStandardOptions === true) {
                    standardFilterOptions = lodash.get(state, 'filter_options.standard', []);
                }
                var filterOptions = angular.copy(typedFilterOptions.concat(standardFilterOptions));
                if (lodash.has(filter, 'operator') && lodash.has(filter, 'option_value')) {
                    var appliedOption = lodash.find(filterOptions, {operator: filter.operator});
                    appliedOption.value = filter.option_value;
                }
                if (lodash.get(filterSettings, 'hasAllOperator', false) === false) {
                    filterOptions = filterOptions.filter(function (_filter) {
                        var operator = lodash.get(_filter, 'operator');
                        return operator.indexOf('_all') < 0;
                    });
                }
                return filterOptions;
            }

            function getMessageLabel(key) {
                return lodash.get(options, ['labels', key].join('.'), '');
            }

            function getLabels() {
                return lodash.get(options, 'labels', {});
            }

            function applySearch() {
                callEvent('refreshGrid');
            }

            function applySort(sort) {
                if (!lodash.has(state, 'applied_sort')) {
                    state.applied_sort = {
                        field: sort.name,
                        dir: lodash.get(state, 'applied_sort', 'asc')
                    };
                } else {
                    if (state.applied_sort.field == sort.name) {
                        state.applied_sort = {
                            field: sort.name,
                            dir: state.applied_sort.dir == 'asc' ? 'desc' : 'asc'
                        };
                    } else {
                        state.applied_sort = {
                            field: sort.name,
                            dir: sort.default_direction
                        };
                    }
                }
                callEvent('refreshGrid');
            }

            function getGeneratedQuery() {
                const query = {
                    search: null,
                    order_by: null
                };

                if (lodash.has(state, 'filter_temp')) {
                    query.filters = state.filter_temp;
                } else {
                    query.filters = state.applied_filters.reduce((result, filter) => {
                        // if (lodash.has(filter, 'operator')) {
                        result.push({
                            name: filter.name,
                            operator: filter.operator,
                            type: filter.type,
                            value: filter.option_value || false // exists and not exists might have have. Unless we want to cater for that also.
                        });
                        // }
                        return result;
                    }, []);
                }

                if (lodash.has(state, 'search_text') && !CommonHelper.isEmpty(state.search_text)) {
                    query.search = state.search_text;
                }

                if (lodash.has(state, 'applied_sort') || !CommonHelper.isEmpty(state.applied_sort)) {
                    query.order_by = state.applied_sort;
                }

                return query;
            }

            function setQuery(query) {
                lodash.set(state, 'search_text', lodash.get(query, 'search', ''));
                if (lodash.has(query, 'order_by') && !CommonHelper.isEmpty(query.order_by)) {
                    lodash.set(state, 'applied_sort', lodash.get(query, 'order_by', null));
                }
                var filters = lodash.get(query, 'filters', null) || lodash.get(state, 'default_filters')

                lodash.set(state, 'filter_temp', filters);
            }

            function setFiltersFromTemp() {

                if (!CommonHelper.isEmpty(lodash.get(state, 'filter_temp', null))) {
                    lodash.set(state, 'applied_filters', lodash.get(state, 'filter_temp', []).map(function (filter) {
                        var filterOptions = getFilterTypeOption(filter);
                        // var filter_obj = lodash.find(filterOptions, '')
                        var filterObj = lodash.find(state.filter_fields, {name: filter.name});
                        var filterOption = lodash.find(filterOptions, {operator: filter.operator});
                        var option_label = '';
                        if (lodash.has(filterOption, 'options.data')) {
                            var selectedOption = lodash.find(filterOption.options.data, {value: filter.value});
                            option_label = selectedOption.label;
                        }
                        return {
                            label: filterObj.label,
                            operator_label: filterOption.label,
                            operator: filter.operator,
                            options: filterObj.options,
                            option_value: filter.value,
                            option_label: option_label,
                            type: filter.type,
                            name: filter.name,
                            _hide_on_load: true,
                            rules: filter.rules,
                            settings: filterObj.settings,
                        };
                    }));
                }
                delete state.filter_temp;
            }

            function reset(retain_default) {
                if (retain_default) {
                    state.applied_filters = lodash
                        .intersectionBy(state.applied_filters, state.filter_fields, 'name')
                        .reduce(function (carry, filter) {
                            if (lodash.get(filter, 'settings.required', false)) {
                                carry.push(filter);
                            }
                            return carry;
                        }, []);
                } else {
                    state.applied_filters = [];
                }
                state.search_text = '';
                state.applied_sort = {};
                callEvent('refreshGrid');
            }

            function getFilterBarOptions() {
                return options;
            }
        };
    }
})();

